import React, { useEffect, useMemo, useState } from 'react';
import { pickBy } from 'lodash';
import Badges from 'modules/common/components/Badge';

import Table from 'partial/components/Table';
import Select from 'partial/components/Select';
import SearchBar from 'partial/components/input/SearchBar';
import Pagination from 'partial/components/Pagination';
import { useModuleContext } from 'partial/wrappers/ModuleWrapper';

import { useMaskNameList } from './hooks';

const INITIAL_STATE = {
  keyword: '',
  status: { label: 'All status', value: '' },
};

const statusOptions = [
  { label: 'All status', value: '' },
  { label: 'Pending', value: 'pending' },
  { label: 'Processing', value: 'processing' },
  { label: 'Approved', value: 'approved' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Failed', value: 'failed' },
  { label: 'Success', value: 'success' },
];

const format = [
  { label: 'MASK NAME', key: 'name' },
  { label: 'ORGANIZATION/USER', key: 'organization_name' },
  { label: 'DATE REQUESTED', key: 'subscribed_at' },
  { label: 'DATE APPROVED', key: 'approved_at' },
  { label: 'EXPIRY DATE', key: 'expired_at' },
  { label: 'REMARKS', key: 'remarks' },
  {
    id: 'status',
    key: ({ status }) => <Badges status={status} />,
    labelClassName: 'whitespace-nowrap flex justify-center',
    contentClassName: 'px-[24px] md:!px-11 whitespace-nowrap text-right',
    label: 'STATUS',
  },
];

export function MaskNamesContent() {
  const { setSubLabel } = useModuleContext();

  const [filter, setFilter] = useState(INITIAL_STATE);
  const [page, setPage] = useState({ page: '' });
  const payload = useMemo(
    () =>
      pickBy({
        ...filter,
        ...page,
        status: filter?.status?.value,
      }),
    [filter, page],
  );

  useEffect(() => {
    setPage({ page: '' });
  }, [filter]);

  const [isLoading, list, meta] = useMaskNameList(payload);

  useEffect(() => {
    if (!meta) return;
    setSubLabel(
      meta?.total === 0
        ? ''
        : `Total of ${meta?.total} mask name${meta?.total === 1 ? '' : 's'}`,
    );
    return () => setSubLabel('');
  }, [meta, setSubLabel]);

  return (
    <section className="p-6 bg-white drop-shadow rounded-lg h-full flex flex-col">
      <div className="mb-5 flex items-center space-x-5">
        <SearchBar
          name="keyword"
          value={filter.keyword}
          onChange={setFilter}
          inputClassName="py-[1.05rem] "
        />
        <Select
          name="status"
          onChange={setFilter}
          value={filter.status}
          data={statusOptions}
        />
      </div>
      <div className="flex flex-col gap-10 min-h-[65vh]">
        <Table isLoading={isLoading} data={list} format={format} />
        <Pagination value={meta} onChange={setPage} />
      </div>
    </section>
  );
}

export default MaskNamesContent;
